import React from 'react';
import { motion } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
export function Testimonials() {
  const testimonials = [{
    quote: 'Vendí mis primeros collares la misma semana',
    name: 'Mariana G.',
    location: 'Córdoba',
    initial: 'M'
  }, {
    quote: 'Nunca había hecho manualidades y hoy tengo pedidos todos los meses',
    name: 'Luciana P.',
    location: 'Rosario',
    initial: 'L'
  }, {
    quote: 'Recuperé la inversión con mis primeras ventas',
    name: 'Carla M.',
    location: 'Buenos Aires',
    initial: 'C'
  }];
  return <section className="py-10 px-4 bg-slate-900 text-white" data-id="element-274">
      <div className="max-w-6xl mx-auto" data-id="element-275">
        <div className="text-center mb-6" data-id="element-276">
          <div className="inline-flex items-center gap-2 text-brand-300 font-bold mb-2 text-sm" data-id="element-277">
            <FavoriteIcon fontSize="small" data-id="element-278" /> CASOS REALES
          </div>
          <h2 className="text-2xl md:text-3xl font-bold" data-id="element-279">
            ❤️ PERSONAS QUE YA EMPEZARON
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-280">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-800 rounded-2xl p-5 border border-slate-700 shadow-xl flex flex-col" data-id="element-281">
              <div className="flex text-yellow-400 mb-2" data-id="element-282">
                {[...Array(5)].map((_, i) => <StarIcon key={i} fontSize="small" data-id="element-283" />)}
              </div>
              <p className="text-base font-medium italic mb-4 flex-grow" data-id="element-284">
                “{test.quote}”
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-285">
                <div className="w-10 h-10 bg-brand-600 rounded-full flex items-center justify-center font-bold text-base" data-id="element-286">
                  {test.initial}
                </div>
                <div data-id="element-287">
                  <p className="font-bold" data-id="element-288">{test.name}</p>
                  <p className="text-slate-400 text-sm" data-id="element-289">{test.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}